import { Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";

import { APPROVAL_ACTION_TYPE } from "../../../constants/enums";
const ConfirmApproveDialog = (props: any) => {
  const {
    warningType,
    setWarningType,
    handleSwitchValue,
    handleStatusUpdate,
    handleBulkStatusUpdate,
    setOpenUpdate,
    bulkUpdateStatusData,
    fromBunitsPreference,
  } = props;
  const handleApprovalAction = (type: any) => {
    if (fromBunitsPreference) {
      if (type === "cancel") {
        handleSwitchValue("cancel");
      } else {
        handleSwitchValue("update");
      }
    } else {
      if (type === "update") {
        handleBulkStatusUpdate(bulkUpdateStatusData, "Bulk");
      }
    }
    setWarningType(false);
  };
  const handleClose = () => {
    setWarningType(false);
    if (fromBunitsPreference) {
      handleSwitchValue("cancel");
    }
  };
  return (
    <div>
      <Dialog className="pw-rejected-dialog-container" open={true}>
        <div className="pw-dialog-container">
          <div className="flex justify-between items-center w-full">
            {fromBunitsPreference ? (
              <div className={`pw-header-text`}>Enable direct approval</div>
            ) : (
              <div className={`pw-header-text`}>
                Update to{" "}
                <span className={`pw-${warningType.toLowerCase()}-option`}>
                  {warningType}
                </span>
              </div>
            )}
            <div className="cursor-pointer">
              <CloseIcon
                className="pw-color-close-attchments"
                onClick={handleClose}
              />
            </div>
          </div>
          <div className="flex justify-between items-center w-full mt-8">
            <div className="text-sm">
              {fromBunitsPreference
                ? "Please note that enabling this feature will directly approve all emissions on creation."
                : "Please note that adding comments or attachments is not allowed for bulk updates."}
            </div>
          </div>
        </div>
        <div className="flex flex-row mt-16 justify-end pw-bunit-footer w-full gap-6">
          <div
            onClick={() => handleApprovalAction(APPROVAL_ACTION_TYPE.CANCEL)}
            className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          >
            Cancel
          </div>
          <div
            onClick={() => handleApprovalAction("update")}
            className={`pw-bunit-button-primary ${
              warningType === "Rejected" && "pw-bg-error"
            } pw-bunit-button-save text-white
               ${"cursor-pointer bg-primary"}`}
          >
            Update
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ConfirmApproveDialog;
